/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

import pluginFactory from 'taoTests/runner/plugin';
import { itemPathForPosition } from '../../../util/testMap.js';

export default pluginFactory({
    name: 'lifecycleEvents',

    install() {
        const testRunner = this.getTestRunner();

        /**
         * Fire a lifecycle event
         * @param {string} type
         * @param {string} scope - 'test' or 'item'
         * @param {object} [detail]
         */
        this.fireEvent = (type, scope, detail) => {
            testRunner.trigger('lifecycleEvent', type, scope, detail);
        };
    },

    init() {
        const testRunner = this.getTestRunner();

        testRunner
            .on('init.lifecycleEvents', () => {
                this.fireEvent('init', 'test');
            })
            .before('loaditem.lifecycleEvents', () => {
                this.fireEvent('init', 'item');
            })
            .after('renderitem.lifecycleEvents', () => {
                this.fireEvent('ready', 'item', {
                    screen: {
                        width: screen.width,
                        height: screen.height
                    },
                    window: {
                        width: window.outerWidth,
                        height: window.outerHeight
                    },
                    document: {
                        width: document.documentElement.clientWidth,
                        height: document.documentElement.clientHeight
                    },
                    userAgent: navigator.userAgent
                });
            })
            .on('move.lifecycleEvents', (direction, scope, position) => {
                let itemIdentifier;
                let response;

                if (typeof position === 'number') {
                    const testMap = testRunner.getTestMap();
                    itemIdentifier = itemPathForPosition(testMap, position).itemId;
                }

                const itemRunner = testRunner.itemRunner;
                if (itemRunner) {
                    response = itemRunner.getResponses();
                }

                this.fireEvent('move', 'item', { scope, direction, itemIdentifier, response });
            })
            .on('finish.lifecycleEvents', () => {
                this.fireEvent('finish', 'test');
            });
    },

    destroy() {}
});
